import { render, staticRenderFns } from "./monthlyLiabilities_detail.vue?vue&type=template&id=da152e82&"
import script from "./monthlyLiabilities_detail.vue?vue&type=script&lang=js&"
export * from "./monthlyLiabilities_detail.vue?vue&type=script&lang=js&"
import style0 from "./monthlyLiabilities_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports